import service from '@/middleware'

const userApi = {
    /**
     * Datos para la tabla del ABM
     * @param {*} pageSize
     * @param {*} pageNumber
     * @param {*} headers
     * @param {*} enterpriseIds
     * @param {*} enterpriseLess
     */
    async findAll(pageSize, pageNumber, headers, enterpriseIds, enterpriseLess) {
        const url = pageSize != null && pageNumber != null
            ? `/api/user/all?pageSize=${pageSize}&pageNumber=${pageNumber}&headers=${headers}`
            : `/api/user/all?headers=${headers}`
        const response = await service.http.post(url, { enterpriseIds, enterpriseLess })
        return response
    },
    /**
     * Total de usuarios para el paginador de la tabla del ABM
     * @param {*} enterpriseIds
     * @param {*} enterpriseLess
     */
    async getTotal (enterpriseIds, enterpriseLess) {
        const result = await service.http.post(`/api/user/total`, { enterpriseIds, enterpriseLess})
        return result
    },
    /**
     * Para obtener un usuario con el id enviado como param
     * @param {*} userId
     */
    async getUser (userId) {
        const result = await service.http.get(`/api/user/${userId}`)
        return result
    },
    /**
     * Para obtener los datos del usuario para actualizar
     * @param {*} userId
     */
    async getUserForABM (userId) {
        const result = await service.http.get(`/api/user/abm-user/${userId}`)
        return result
    },
    /**
     * Para validar el nombre de un usuario
     * @param {*} username
     */
    async validateUsername (username) {
        const result = await service.http.get(`/api/user/validate-username/${username}`)
        return result
    },
    /**
     * Para crear un nuevo usuario
     * @param {*} userDto
     * @param {*} sendEmail
     */
    async create (userDto, sendEmail = false) {
        const result = await service.http.post(`/api/user/create`, { userDto, sendEmail })
        return result
    },
    /**
     * Para actualizar un usuario
     * @param {*} userDto
     */
    async update (userDto) {
        const result = await service.http.put(`/api/user/update`, userDto)
        return result
    },
    /**
     * Para eliminar un usuario
     * @param {*} id
     */
    async deleteOne (id) {
        const result = await service.http.delete(`/api/user/${id}`)
        return result
    },
    /**
     * Eliminación múltiple
     * @param {*} ids 
     */
    async deleteMany (ids) {
        const result = await service.http.put(`/api/user/multiple-delete`, ids)
        return result
    },

    /**
     * Deshabilitar usuarios
     * @param {*} ids
     */
    async disable (ids) {
        const result = await service.http.put(`/api/user/disable`, ids)
        return result
    },

    /**
     * Para obtener los usuarios para los selectores
     */
    async getAllForSelector () {
        const result = await service.http.get(`/api/user/all-for-selector`)
        return result
    },

    /**
     * Para obtener la configuración de autoUpdateEnterprises para un usuario
     * @param {*} userId
     */
    async getAutoUpdateEnterprises (userId) {
        const result = await service.http.get(`/api/user/get-auto-update-user-enterprises/${userId}`)
        return result
    },

    /**
     * Para establecer la configuración de autoUpdateEnterprises para un usuario
     * @param {*} userId
     * @param {*} enabled
     */
    async setAutoUpdateEnterprises (userId, enabled) {
        const result = await service.http.post(`/api/user/set-auto-update-user-enterprises`, { userId, enabled })
        return result
    },
}

export default userApi
